import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ScalarClientApiService } from "@shared/services/scalar/scalar-client-api.service";
import { LogService } from "@shared/services/log.service";

@Component({
    selector: "my-scalar-close",
    templateUrl: "./scalar-close.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./scalar-close.component.scss"]
})
export class ScalarCloseComponent {
    constructor(private readonly scalar: ScalarClientApiService, private readonly logService: LogService) {}

    public closeScalar() {
        this.logService.debug("Closing Dimension...");
        this.scalar.close();
    }
}
